export default __webpack_public_path__ + "static/media/1906.8d763a44.png";